(ns portal.forgot-password-page.db
  (:require [clojure.spec.alpha :as spec]
            [clojure.string :as str]
            [common.form.core :as form]
            [phrase.alpha :as p]
            [re-frame.core :as rf]))

(defn email?
  [email]
  (re-matches #".+\@.+\..+" email))

(spec/def ::email
  (spec/and (complement str/blank?)
            email?))

(spec/def ::value
  (spec/keys :req-un [::email]))

(p/defphraser (complement str/blank?)
  [_ problem]
  {:message "The field should not be empty"
   :in (:in problem)
   :problem problem})

(p/defphraser email?
  [_ problem]
  {:message "Not a valid email address"
   :in (:in problem)
   :problem problem})

(def validate-form
  (rf/enrich
   (form/get-validate-form-fn :form.forgot-password ::value)))

(def initial-value
  {:email ""})

(def forward-events
  [{:events #{:resource.user/request-reset-password-success}
    :dispatch-to [:form.forgot-password/submit-success]}
   {:events #{:resource.user/request-reset-password-failure}
    :dispatch-to [:form.forgot-password/submit-failure]}])

(form/register-form {:namespace :form.forgot-password
                     :initial-value initial-value
                     :forward-events forward-events
                     :validate-form validate-form
                     :submit-event :form.forgot-password/submit-form})

(rf/reg-event-fx :form.forgot-password/submit-form
  (fn [{:keys [db]} [_ payload]]
    {:db (assoc-in db [:form.forgot-password :state]
                   {:status :pending
                    :email (:email payload)})
     :dispatch [:resource.user/request-reset-password payload]}))

(rf/reg-event-db :form.forgot-password/submit-success
  (fn [db]
    (assoc-in db [:form.forgot-password :state :status] :success)))

(rf/reg-event-db :form.forgot-password/submit-failure
  (fn [db]
    (assoc-in db [:form.forgot-password :state :status] :failure)))

(rf/reg-sub :form.forgot-password/state
  (fn [db]
    (get-in db [:form.forgot-password :state])))

(rf/reg-sub :form.forgot-password/reset-token-expired?
  :<- [:url-context]
  (fn [url-context]
    (some? (:token-expired url-context))))

(def use-bind-control (partial form/use-bind-control :form.forgot-password))
(def use-error-message (partial form/use-error-message :form.forgot-password))
